import * as TEMPLATES from './templates.constants';
import { Template } from '@models/index';

/** LOAD */
export function loadTemplates() {
    return { type: TEMPLATES.TEMPLATES_LOAD };
}

export function loadTemplatesSuccess(data: Template[]) {
    return { type: TEMPLATES.TEMPLATES_LOAD_SUCCESS, payload: data };
}

export function loadTemplatesError(error: any) {
    return { type: TEMPLATES.TEMPLATES_LOAD_ERROR, payload: error };
}


/** ADD */
export function addTemplates(targetTemplates: Template[]) {
    return { type: TEMPLATES.TEMPLATES_ADD, payload: targetTemplates };
}

export function addTemplatesSuccess(targetTemplates: Template[]) {
    return { type: TEMPLATES.TEMPLATES_ADD_SUCCESS, payload: targetTemplates };
}

export function addTemplatesError(error: any) {
    return { type: TEMPLATES.TEMPLATES_ADD_ERROR, payload: error };
}

export function addTemplate(targetTemplate: Template) {
    return { type: TEMPLATES.TEMPLATE_ADD, payload: targetTemplate };
}

export function addTemplateSuccess(targetTemplate: Template) {
    return { type: TEMPLATES.TEMPLATE_ADD_SUCCESS, payload: targetTemplate };
}

export function addTemplateError(error: any) {
    return { type: TEMPLATES.TEMPLATE_ADD_ERROR, payload: error };
}


/** UPDATE */
// export function updateTemplates(targetTemplates: Template[]) {
//     return { type: TEMPLATES.TEMPLATES_UPDATE, payload: targetTemplates };
// }

// export function updateTemplatesSuccess(targetTemplates: Template[]) {
//     return { type: TEMPLATES.TEMPLATES_UPDATE_SUCCESS, payload: targetTemplates };
// }

// export function updateTemplatesError(error: any) {
//     return { type: TEMPLATES.TEMPLATES_UPDATE_ERROR, payload: error };
// }


/** DELETE */
export function deleteTemplates(guids: string[]) {
    return { type: TEMPLATES.TEMPLATES_DELETE, payload: guids };
}

export function deleteTemplatesSuccess(Templates: Template[]) {
    return { type: TEMPLATES.TEMPLATES_DELETE_SUCCESS, payload: Templates };
}

export function deleteTemplatesError(error: any) {
    return { type: TEMPLATES.TEMPLATES_DELETE_ERROR, payload: error };
}

export function deleteTemplate(guid: string) {
    return { type: TEMPLATES.TEMPLATE_DELETE, payload: guid };
}

export function deleteTemplateSuccess(guid: string) {
    return { type: TEMPLATES.TEMPLATE_DELETE_SUCCESS, payload: guid };
}

export function deleteTemplateError(error: any) {
    return { type: TEMPLATES.TEMPLATE_DELETE_ERROR, payload: error };
}